import React, { Fragment } from "react";
import { useTagValues, useResourceTagValues } from "../data";
import TagItem from "../tag-item";
import {LinearProgress} from '@material-ui/core';

const EmptyItem = ({ contextId, contextType, selected }) => {
  return <TagItem isResource={true} isNew={true} tag="" value="" contextType={contextType} contextId={contextId} selected={selected} />;
};

const TagValuesList = ({ data, contextId, contextType, isResource, loading }) => {
  const items = data.map(metadata => {
    return (
      <TagItem
        key={metadata.tag.id}
        isResource={isResource}
        isNew={false}
        tag={metadata.tag.id}
        value={metadata.value}
        contextType={contextType}
        contextId={contextId}
      />
    );
  });
  return (
    <Fragment>
      {loading ? 
        <LinearProgress/> :
        <div>
          {items}
          <EmptyItem contextType={contextType} contextId={contextId} selected={data}/>
        </div>
      }
    </Fragment>
  );
};

const TagsValuesResource = ({ contextId, contextType, isResource }) => {
  const { data, loading } = useResourceTagValues({ resource: contextId });
  return <TagValuesList data={data} contextId={contextId} contextType={contextType} isResource={isResource} loading={loading}/>;
};

const TagsValuesNotResource = ({ contextId, contextType, isResource  }) => {
  const { data, isSafe, loading } = useTagValues(contextType, contextId);
  return <TagValuesList data={data} contextId={contextId} contextType={contextType} isResource={isResource}  loading={loading}/>;
};

const TagValues = ({ contextId, contextType, isResource }) => {
  if (isResource) {
    return <TagsValuesResource contextId={contextId} contextType={contextType} isResource={isResource}  />;
  } else {
    return <TagsValuesNotResource contextId={contextId} contextType={contextType} isResource={isResource} />;
  }
};

export default TagValues;



// WEBPACK FOOTER //
// ./src/components/tags-manager/tag-values/index.js